import { render, staticRenderFns } from "./EmployeeInfoBlock.vue?vue&type=template&id=0797400c&scoped=true"
import script from "./EmployeeInfoBlock.vue?vue&type=script&lang=js"
export * from "./EmployeeInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0797400c",
  null
  
)

export default component.exports